<template>
  <div>
    <b-modal :active.sync="activePrompt" centered  v-model="activePrompt" size="lg" title="Work Detail">
      <vs-progress :percent="viewpercentage" color="success">success</vs-progress><br>
        Work Progress {{viewpercentage}}% Completed!<br><br>
      <vs-row>
        <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
          <p v-if="viewwork" style="font-size: 100%">
          Started by: {{viewwork.username}}<br>
          Asset: -<br>
          Work detail: {{viewwork.detail}}<br>
          Created Date: {{viewwork.timestamp}}<br>
          Last edited: {{viewwork.editdate}}<br>
          Time Spent: {{viewwork.timespent}}
          </p>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
          <p v-if="viewwork" style="font-size: 100%">
          Start Date: {{viewwork.plandate}}<br>
          Actual start date: {{viewwork.startdate}}<br>
          End Date: {{viewwork.duedate}}<br>
          Actual End Date: {{viewwork.finishtime}}<br>
          Status: {{viewwork.iscomplete}}<br>
          WO Status : 
          </p>
        </vs-col>
        <vs-divider></vs-divider>
      </vs-row>
      <FormRenderer :form-configuration="formData" v-model="formInputData"/>
    </b-modal>
  </div>
</template>

<script>
import {FormRenderer} from 'v-form-builder';
export default {
  name: 'WO',
  components: {
    FormRenderer,
  },
  props: [
    'viewwork',
  ],
  computed: {
  },
  data: () => ({
    role: '',
    viewpercentage: 0,
    formData: '',
    activePrompt: false,
  }),
  methods: {
    view() {
    },
  },
  mounted() {
    this.role = this.$session.get('role')
    // console.log('mounting table')
    this.viewpercentage = 0
    var maxitem = 0
    var nullitem = 0
    var item = this.viewwork
    // console.log(item)
    this.formData = item.form
    this.activePrompt = true
    setTimeout(() => {
      this.formInputData = item.inputdata
      // console.log(this.formInputData)
      if(item.inputdata) {
        Object.keys(item.inputdata).forEach(element => {
          maxitem += 1
          if(item.inputdata[element] == null || item.inputdata[element] == 0 || item.inputdata[element] == '') {
            nullitem += 1
          }
        });
        this.viewpercentage = ([(maxitem-nullitem)/maxitem]*100).toFixed(2)
      }
    }, 200);
  }
}
</script>